import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@mui/material';

import CircularProgress from '../../../common/CircularProgress';
import { useMessages } from '../../../../hooks/useMessages';
import { FIELDS as F } from '../../../../services/consumerFields';
import * as DM from '../../../../services/dataModel';
import { dialogShowCustom } from '../../../../store/actions/dialogActions';

import OtpPhoneDialog from './OtpPhoneDialog';
import {
    executeSendOtp,
    executeVerifyOtp,
} from '../../../../store/actions/otpPhoneActions';

const OtpPhoneUpdate = () => {
    const dispatch = useDispatch();
    const { L } = useMessages();

    const model = useSelector((state) => state.profile);

    const { user } = useSelector((state) => state.auth);
    const { hasConsumerUpdate } = user || {};

    const { loading, token } = useSelector((state) => state.otpPhone);

    const isActive = DM.getValue(model, F.IS_ACTIVE_EX);
    const isDeleted = DM.getValue(model, F.IS_DELETED);
    const profileStatus = DM.getValue(model, F.PROFILE_VERIFICATION_STATUS);
    const isVerified = profileStatus === 'VERIFIED';

    const canChange = hasConsumerUpdate && isActive && !isDeleted && isVerified;

    const label = token
        ? L.consumerpage_personal_btn_phone_verify
        : L.consumerpage_personal_btn_phone_change;

    const handleDialogConfirm = useCallback(
        (dialogModel) => {
            if (!dialogModel.token) {
                // Step 1 - send OTP
                const consumerId = DM.getValue(model, F.UID);
                const phoneNumber = DM.getNormalized(
                    DM.getCurrentValue(dialogModel, F.MOBILE_NUMBER)
                );
                const lang = DM.getValue(model, F.LANGUAGES);
                const params = {
                    consumerId,
                    phoneNumber,
                    lang,
                };
                dispatch(executeSendOtp(params));
            } else {
                // Step 2 - verify OTP
                const consumerId = DM.getValue(model, F.UID);
                const code = DM.getNormalized(
                    DM.getCurrentValue(dialogModel, F.MOBILE_OTP_CODE)
                );
                const params = {
                    consumerId,
                    vToken: dialogModel.token,
                    code,
                };
                dispatch(executeVerifyOtp(params));
            }
        },
        [dispatch, model]
    );

    const handleClick = () => {
        dispatch(dialogShowCustom(OtpPhoneDialog, handleDialogConfirm));
    };

    return (
        <>
            {(loading && <CircularProgress size="1.25rem" />) || (
                <Button
                    variant="text"
                    color="primary"
                    size="small"
                    disabled={!canChange}
                    onClick={handleClick}
                    sx={{ marginY: '-8px' }}
                >
                    {label}
                </Button>
            )}
        </>
    );
};

export default OtpPhoneUpdate;
